import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/account-categories';
// const URL = 'https://nodeapi.nurutama.id/account-categories';
const URL = BASE_URL + '/account-categories';

const getAccountList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createAccount = async (data) => {
  try {
    const result = await axios.post(URL, data);
    return result.data; // Mengembalikan hasil jika berhasil
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the account.');
    }
  }
};

const updateAccount = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error updating the account.');
    }
  }
};

const deleteAccount = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getAccountById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getAccountList,
  createAccount,
  updateAccount,
  deleteAccount,
  getAccountById,
};
